import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { DixaMessengerApiV2 } from 'components/settings/components/sections/dixaMessenger/api/dixaMessengersApi';
export const dixaMessengerApi = new DixaMessengerApiV2();
const DixaMessengerApiContext = React.createContext(dixaMessengerApi);
export function useDixaMessengerApi() {
    const api = React.useContext(DixaMessengerApiContext);
    return api;
}
export function DixaMessengerApiProvider({ children, }) {
    return (_jsx(DixaMessengerApiContext.Provider, Object.assign({ value: dixaMessengerApi }, { children: children })));
}
